import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "text-success" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-history mr-1" }),
  /*#__PURE__*/_createTextVNode(" History")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "mt-2 mb-3 timeline-fixed-height custom-scroll bg-light p-3 rounded"
}
const _hoisted_4 = { class: "timeline" }
const _hoisted_5 = { class: "timeline-item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", { class: "m-0 d-none" }, " ", -1)
const _hoisted_7 = { class: "time-show mt-0" }
const _hoisted_8 = {
  href: "#",
  class: "btn btn-primary width-lg"
}
const _hoisted_9 = { class: "timeline-desk" }
const _hoisted_10 = { class: "timeline-box" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "arrow-alt" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "timeline-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-dot-circle" })
], -1)
const _hoisted_13 = { class: "bg-light p-3 mb-2 rounded border" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
  /*#__PURE__*/_createVNode("small", { class: "font-8 align-middle" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-circle mr-1" })
  ]),
  /*#__PURE__*/_createVNode("strong", null, "Previous Details")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-dollar-sign mr-1" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Estimated Budget : ")
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar mr-1" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Date : ")
const _hoisted_22 = {
  key: 0,
  class: "text-success",
  title: "Start Date"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_24 = {
  key: 1,
  class: "text-danger",
  title: "End Date"
}
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "far fa-file mr-1" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" E-doc : ")
const _hoisted_28 = {
  key: 4,
  class: "timeline-album"
}
const _hoisted_29 = {
  key: 5,
  class: "timeline-album"
}
const _hoisted_30 = { class: "bg-light p-3 mb-2 rounded border" }
const _hoisted_31 = /*#__PURE__*/_createVNode("p", {
  class: "text-success",
  title: "Edited"
}, [
  /*#__PURE__*/_createVNode("small", { class: "font-8 align-middle" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-circle mr-1" })
  ]),
  /*#__PURE__*/_createVNode("strong", null, " New Details"),
  /*#__PURE__*/_createVNode("small", { class: "text-muted" }, [
    /*#__PURE__*/_createVNode("i", null, "Edited")
  ])
], -1)
const _hoisted_32 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fa fa-dollar-sign mr-1" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Estimated Budget : ")
const _hoisted_36 = { key: 2 }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar mr-1" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Date : ")
const _hoisted_39 = {
  key: 0,
  class: "text-success",
  title: "Start Date"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_41 = {
  key: 1,
  class: "text-danger",
  title: "End Date"
}
const _hoisted_42 = { key: 3 }
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "far fa-file mr-1" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" E-doc : ")
const _hoisted_45 = {
  key: 4,
  class: "timeline-album"
}
const _hoisted_46 = {
  key: 5,
  class: "timeline-album"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.history && _ctx.history.length)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.history, (history, historyIndex) => {
              return (_openBlock(), _createBlock("div", { key: historyIndex }, [
                _createVNode("article", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("div", _hoisted_7, [
                    _createVNode("a", _hoisted_8, _toDisplayString(history.date), 1)
                  ])
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(history.changes, (change, changeIndex) => {
                  return (_openBlock(), _createBlock("article", {
                    class: 
              changeIndex % 2 == 0
                ? 'timeline-item timeline-item-left'
                : 'timeline-item'
            ,
                    key: changeIndex
                  }, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _hoisted_12,
                        _createVNode("div", _hoisted_13, [
                          _hoisted_14,
                          (change.old_description)
                            ? (_openBlock(), _createBlock("p", _hoisted_15, _toDisplayString(change.old_description), 1))
                            : _createCommentVNode("", true),
                          (change.old_budget)
                            ? (_openBlock(), _createBlock("p", _hoisted_16, [
                                _hoisted_17,
                                _hoisted_18,
                                _createVNode("small", null, " $" + _toDisplayString(change.old_budget), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (change.old_start_date || change.old_end_date)
                            ? (_openBlock(), _createBlock("p", _hoisted_19, [
                                _hoisted_20,
                                _hoisted_21,
                                (change.old_start_date)
                                  ? (_openBlock(), _createBlock("small", _hoisted_22, _toDisplayString(change.old_start_date), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_23,
                                (change.old_end_date)
                                  ? (_openBlock(), _createBlock("small", _hoisted_24, _toDisplayString(change.old_end_date), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (change.old_edoc_id)
                            ? (_openBlock(), _createBlock("p", _hoisted_25, [
                                _hoisted_26,
                                _hoisted_27,
                                _createVNode("small", null, " $" + _toDisplayString(change.old_edoc_id), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (change.old_documents)
                            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(change.old_documents, (oldDocs, oldIndex) => {
                                  return (_openBlock(), _createBlock("a", {
                                    href: "javascript: void(0);",
                                    key: oldIndex
                                  }, [
                                    _createVNode("img", {
                                      alt: "",
                                      src: oldDocs.activeLink,
                                      title: oldDocs.file_name
                                    }, null, 8, ["src", "title"])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (change.old_payers && change.old_payers.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(change.old_payers, (oldMember, oldMemberIndex) => {
                                  return (_openBlock(), _createBlock("a", {
                                    href: "javascript: void(0);",
                                    key: oldMemberIndex
                                  }, [
                                    (oldMember.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          alt: oldMember.email,
                                          src: oldMember.image
                                        }, null, 8, ["alt", "src"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          title: oldMember.email,
                                          src: 
                          _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                            : 'img/no-user.jpg'
                        ,
                                          alt: ""
                                        }, null, 8, ["title", "src"]))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_30, [
                          _hoisted_31,
                          (change.new_description)
                            ? (_openBlock(), _createBlock("p", _hoisted_32, _toDisplayString(change.new_description), 1))
                            : _createCommentVNode("", true),
                          (change.new_budget)
                            ? (_openBlock(), _createBlock("p", _hoisted_33, [
                                _hoisted_34,
                                _hoisted_35,
                                _createVNode("small", null, " $" + _toDisplayString(change.new_budget), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (change.new_start_date || change.new_end_date)
                            ? (_openBlock(), _createBlock("p", _hoisted_36, [
                                _hoisted_37,
                                _hoisted_38,
                                (change.new_start_date)
                                  ? (_openBlock(), _createBlock("small", _hoisted_39, _toDisplayString(change.new_start_date), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_40,
                                (change.new_end_date)
                                  ? (_openBlock(), _createBlock("small", _hoisted_41, _toDisplayString(change.new_end_date), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (change.new_edoc_id)
                            ? (_openBlock(), _createBlock("p", _hoisted_42, [
                                _hoisted_43,
                                _hoisted_44,
                                _createVNode("small", null, " $" + _toDisplayString(change.new_edoc_id), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (change.new_documents)
                            ? (_openBlock(), _createBlock("div", _hoisted_45, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(change.new_documents, (newDoc, newIndex) => {
                                  return (_openBlock(), _createBlock("a", {
                                    href: "javascript: void(0);",
                                    key: newIndex
                                  }, [
                                    _createVNode("img", {
                                      alt: "",
                                      src: newDoc.activeLink,
                                      title: newDoc.file_name
                                    }, null, 8, ["src", "title"])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (change.new_payers && change.new_payers.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(change.new_payers, (newMember, newMemberIndex) => {
                                  return (_openBlock(), _createBlock("a", {
                                    href: "javascript: void(0);",
                                    key: newMemberIndex
                                  }, [
                                    (newMember.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          alt: newMember.email,
                                          src: newMember.image
                                        }, null, 8, ["alt", "src"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          title: newMember.email,
                                          src: 
                          _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                            : 'img/no-user.jpg'
                        ,
                                          alt: ""
                                        }, null, 8, ["title", "src"]))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ], 2))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createBlock(_component_EmptyData, {
          key: 1,
          title: _ctx.state.data.historyTitle,
          heading: _ctx.state.data.historyHeading
        }, null, 8, ["title", "heading"]))
  ]))
}